import React from "react";
import { Avatar } from "ui-components";
import { gotoUrl, randomNumber, urlParam } from "utils/helpers";
import { CALL_BACK_URL } from "utils/constants";
import { useLocation } from "react-router-dom";
import {
  APP_REDIRECT_PATH,
  setItem,
  SOCIAL_MEDIA_STATE
} from "utils/localStorage";
import SocialMediaCard from "./SocialMediaCard";

const AUIcon = ({
  iconUrl,
  socialLoginUrl: auAuthUrl,
  channelId,
  overrideParams = {},
  largeIcons = false,
  label,
  name
}) => {
  const { pathname } = useLocation();
  const path = pathname.replace(/\//g, "z");
  const state = `${randomNumber()}${path}`;
  const redirect = urlParam("redirect");

  /**
   * OverrideParams can be used to override default values or to inject any
   * additional params.It is coming from generic.social_media_signin_options
   */
  const onClickEvent = () => {
    const urlParams = {
      response_type: "code",
      client_id: channelId,
      redirect_uri: CALL_BACK_URL.AU,
      state: state,
      ...overrideParams
    };

    if (auAuthUrl) {
      setItem(SOCIAL_MEDIA_STATE, state);
      // Sets redirect url to redirect after loggin
      redirect && setItem(APP_REDIRECT_PATH, redirect);
      gotoUrl(auAuthUrl, false, {}, false, urlParams);
    }
  };

  return largeIcons ? (
    <SocialMediaCard
      onClick={onClickEvent}
      label={label || name}
      iconUrl={iconUrl}
    />
  ) : (
    <Avatar
      src={iconUrl}
      onClick={onClickEvent}
      data-testid="au-icon"
      style={{ cursor: "pointer" }}
    />
  );
};

export default AUIcon;
